import CloseIcon from '@/common/assets/icons/closeCircleIcon.svg?react';
import { TextareaAttachmentType } from '@/common/components/base/textarea/base/CommonInput.type';
import createAttachment from '@/common/components/base/textarea/base/helpers/createAttachment';

const formResetAttachment = ({
  onReset,
  renderCondition,
}: {
  onReset: () => void;
  renderCondition?: boolean;
}): TextareaAttachmentType => {
  return createAttachment({
    shouldRender: renderCondition ?? true,
    element: <CloseIcon onClick={onReset} />,
    size: 'small',
  });
};
export default formResetAttachment;
